/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matches_RunInputs */

const cs_matches_run = /** @type {(inputs: Matches_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit párování`)
};

const en_matches_run = /** @type {(inputs: Matches_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run matching`)
};

/**
* | output |
* | --- |
* | "Run matching" |
*
* @param {Matches_RunInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const matches_run = /** @type {((inputs?: Matches_RunInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matches_RunInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_matches_run(inputs)
	return cs_matches_run(inputs)
});